import { render, staticRenderFns } from "./PrestoOnline.vue?vue&type=template&id=5a4d95c1&scoped=true&"
import script from "./PrestoOnline.vue?vue&type=script&lang=js&"
export * from "./PrestoOnline.vue?vue&type=script&lang=js&"
import style0 from "./PrestoOnline.vue?vue&type=style&index=0&id=5a4d95c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4d95c1",
  null
  
)

export default component.exports